import React, { useEffect, useState } from "react";
import { getAllPrivacyPolicyAndTermandCondition } from "../../hooks/services/api-services";
import { LoaderSpinner, toastEmitter } from "../../utils/utilities";
import { API_RESPONSE } from "../../utils/app-constants";
import { FRAMEIMG, NOAVAILABILITYADDED } from "../../utils/aap-image-constant";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";

const ReschedulingPolicy = () => {
  const [pending, setPending] = useState(false);
  const [termData, setTermData] = useState([]);
  const { i18n, t } = useTranslation();

  const fetchAllPrivacyAndPolicy = async () => {
    setPending(true);
    try {
      const response = await getAllPrivacyPolicyAndTermandCondition("Rescheduling Policy");
      if (response?.data?.status === 200) {
        setTermData(response?.data?.data || []);
      } 
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    fetchAllPrivacyAndPolicy();
  }, []);

  return (
    <div className="container">
      <div className="pt-4 text-center">
        <div className="">
          <img src={FRAMEIMG} alt="Icon" className="mb-2" />
          <h2 className="mb-1">{t("reschedulingPolicy")}</h2>
          <p className="mb-0">{t("weAreHereToHelp")}</p>
        </div>
      </div>
      {pending ? <LoaderSpinner /> :
        <div className=" py-4">
          {termData ?
            <div><p> {parse(`${i18n.language === "en" ? termData?.englishContent : i18n.language === "ar" ? termData?.arabicContent : termData?.franchContent}`)}</p></div>
            :
            <div className="text-center">
              <img
                src={NOAVAILABILITYADDED}
                alt="No Data Found"
                style={{ maxWidth: "300px", width: "100%" }}
                className="img-fluid"
              />
              <p className="mt-2 fw-600 fs-16">No Term And Condition Found</p>
            </div>
          }
        </div>
      }
    </div>
  );
};

export default ReschedulingPolicy;
